import Vue from 'vue';
import { storeGet } from '@/store/store-utils';

function initialState() {
  return {
    menu: [
      { product: true, title: 'Manuals', bgcolor: 'primary' },
    ],
    available: false,
    availableProduct: '',
    availableClientId: '',
    availabilityRequestId: 0,
  };
}

function rootClientId(rootState) {
  const rawClient = rootState.client || rootState.user?.client || '';
  if (rawClient && typeof rawClient === 'object') {
    return String(rawClient._id || rawClient.id || '');
  }
  return String(rawClient || '');
}

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    START_AVAILABILITY(state) {
      state.availabilityRequestId += 1;
      state.available = false;
      state.availableProduct = '';
      state.availableClientId = '';
    },
    SET_AVAILABLE(state, { available, product, clientId, requestId }) {
      if (requestId !== state.availabilityRequestId) return;
      state.available = Boolean(available);
      state.availableProduct = product || '';
      state.availableClientId = clientId || '';
    },
  },
  actions: {
    async fetchAvailability({ commit, rootState, state }, { product } = {}) {
      const key = String(product || '').trim();
      const clientId = rootClientId(rootState);
      commit('START_AVAILABILITY');
      const requestId = state.availabilityRequestId;
      if (!key) {
        commit('SET_AVAILABLE', { available: false, product: '', clientId, requestId });
        return;
      }
      try {
        const response = await storeGet(Vue.axios, rootState, '/manuals/available', {
          product: key,
        });
        const available = Boolean(response && response.data && response.data.available);
        console.log('[ManualsStore]:', { product: key, clientId, available });
        commit('SET_AVAILABLE', { available, product: key, clientId, requestId });
      } catch (error) {
        console.error('[ManualsStore]: fetchAvailability error', error);
        commit('SET_AVAILABLE', { available: false, product: key, clientId, requestId });
      }
    },
    async fetchPage({ rootState }, { path } = {}) {
      try {
        return await storeGet(Vue.axios, rootState, path, {}, {
          responseType: 'text',
          validateStatus: () => true,
        });
      } catch (error) {
        console.error('[ManualsStore]: fetchPage error', error);
        throw error;
      }
    },
    async fetchAsset({ rootState }, { path } = {}) {
      try {
        return await storeGet(Vue.axios, rootState, path, {}, {
          responseType: 'blob',
          validateStatus: () => true,
        });
      } catch (error) {
        console.error('[ManualsStore]: fetchAsset error', error);
        throw error;
      }
    },
  },
  getters: {
    isAvailable: (state) => state.available,
  },
};
